import { render, staticRenderFns } from "./ProjectAttributeForm.vue?vue&type=template&id=53b77962"
import script from "./ProjectAttributeForm.vue?vue&type=script&lang=js"
export * from "./ProjectAttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports